import { _ } from '@ngx-translate/core';

import { SendByNotification, SendByNotificationCodeEnum } from './types';

export const SEND_BY_NOTIFICATIONS: SendByNotification[] = [
  {
    code: SendByNotificationCodeEnum.sendByDefault,
    default: true,
    notShowFor: ['onBirthdaysDaily'],
    title: _('components.notifications.constants.sendByDefaultTitle'),
    description: _('components.notifications.constants.sendByDefaultDescription'),
  },
  {
    code: SendByNotificationCodeEnum.sendByEmail,
    notShowFor: ['onLoyaltySendCollection'],
    title: _('components.notifications.constants.sendByEmailTitle'),
  },
  {
    code: SendByNotificationCodeEnum.sendByPush,
    notShowFor: ['onNewsletterCreated'],
    title: _('components.notifications.constants.sendByPushTitle'),
  },
  {
    code: SendByNotificationCodeEnum.sendByBot,
    notShowFor: ['onLoyaltySendCollection'],
    title: _('components.notifications.constants.sendByBotTitle'),
  },
];
